module.exports = __webpack_public_path__ + "static/media/mail.5969af22.svg";